import { render, staticRenderFns } from "./singleSelect.vue?vue&type=template&id=aa5449dc&"
import script from "./singleSelect.vue?vue&type=script&lang=js&"
export * from "./singleSelect.vue?vue&type=script&lang=js&"
import style0 from "./singleSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports